/* 다국어(multilingual) 문자열 helper.
   ml 객체 형태: { ko: '...', en: '...', ... } */

export const ml = (obj) => obj || {};

export const mlGet = (obj, lang, fallback = 'ko') =>
  (obj && (obj[lang] || obj[fallback] || obj[Object.keys(obj)[0]])) || '';
